import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Card from '../../../components/Card/Card';
import CarItem from './CarItem';
import { prepareVehicleList } from '../../../utils/helpers';
import { IconPlus } from '../../../assets/icon';

const cardBodyClassName = 'pt-0';
const containerClassName = [
  'flex flex-col sm:flex-row sm:flex-wrap gap-[12px] border border-dashed border-[#F4F4F4] rounded-[4px]',
  'p-[15px] mb-[20px]'
].join(' ');
const addItemClassName = [
  'cursor-pointer border border-dashed border-[#F4F4F4] rounded-[4px]',
  'p-[9.75px] flex items-center justify-center w-full',
  'sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-12px)] xl:max-w-[230px]'
].join(' ');

const CarsList = ({ openModal }) => {
  const { carList } = useSelector((state) => ({
    carList: state?.getListingCompatibilityList.data,
  }), shallowEqual);

  const preparedList = prepareVehicleList(carList || []);

  return (
    <Card
      headerTitle="Cars list"
      showHeader
      headerBordered={false}
      styleBodyContainer={cardBodyClassName}
    >
      <div className={containerClassName}>
        {preparedList
          && Object.keys(preparedList)?.map((item) => (
            <CarItem
              key={item}
              make={item}
              model={(preparedList[item].model || [])?.join(',')}
              year={(preparedList[item].year || [])?.join(',')}
              openModal={openModal}
            />
          ))}
        <div
          className={addItemClassName}
          role="presentation"
          onClick={openModal}
        >
          <IconPlus height={50} width={50} color="#009EF7" />
        </div>
      </div>
    </Card>
  );
};

CarsList.propTypes = {
  openModal: PropTypes.func
};

CarsList.defaultProps = {
  openModal: () => {}
};

export default CarsList;
